const DEFAULT_LANGUAGE = "en";

export function selectedCalendarLanguage() {
  return globalThis.localStorage.getItem("selected_lang") || document.documentElement.lang || DEFAULT_LANGUAGE;
}

export function flatpickrLocale(language = selectedCalendarLanguage()) {
  const locale = supportedLocale(language);
  const shortWeekday = new Intl.DateTimeFormat(locale, {
    weekday: "short",
    timeZone: "UTC"
  });
  const longWeekday = new Intl.DateTimeFormat(locale, {
    weekday: "long",
    timeZone: "UTC"
  });
  const shortMonth = new Intl.DateTimeFormat(locale, {
    month: "short",
    timeZone: "UTC"
  });
  const longMonth = new Intl.DateTimeFormat(locale, {
    month: "long",
    timeZone: "UTC"
  });

  return {
    weekdays: {
      // 2023-01-01 was a Sunday. Flatpickr expects Sunday at index zero.
      shorthand: Array.from({ length: 7 }, (_, index) => shortWeekday.format(utcDate(1 + index))),
      longhand: Array.from({ length: 7 }, (_, index) => longWeekday.format(utcDate(1 + index)))
    },
    months: {
      shorthand: Array.from({ length: 12 }, (_, index) => shortMonth.format(utcDate(1, index))),
      longhand: Array.from({ length: 12 }, (_, index) => longMonth.format(utcDate(1, index)))
    },
    firstDayOfWeek: firstDayOfWeek(locale)
  };
}

export function protectFlatpickrTranslation(instance) {
  instance.calendarContainer.classList.add("notranslate");
  instance.calendarContainer.setAttribute("translate", "no");
}

function utcDate(day, month = 0) {
  return new Date(Date.UTC(2023, month, day));
}

function supportedLocale(language) {
  try {
    return Intl.DateTimeFormat.supportedLocalesOf([language])[0] || DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

function firstDayOfWeek(locale) {
  try {
    const localeInfo = new Intl.Locale(locale);
    const weekInfo = localeInfo.weekInfo || localeInfo.getWeekInfo?.();
    // Intl uses 1–7 (Monday–Sunday); Flatpickr uses 0–6 (Sunday–Saturday).
    return weekInfo ? weekInfo.firstDay % 7 : 0;
  } catch {
    return 0;
  }
}
